import { Box } from '@/components/Box/Box';
import StatusHintIcon from '@/images/StatusHintIcon.svg?react';
import { Tooltip } from '@/components/Tooltip/Tooltip';

export const ExpirationDateLabel = () => {
  return (
    <>
      <Tooltip id='expiration-date-tooltip' place='top-start'>
        Expiration period should be between
        <br /> 1 day and 1 year from today.
      </Tooltip>
      <Box display='flex' flexDirection='row' columnGap='4px' data-tooltip-id='expiration-date-tooltip'>
        <>Expiration Date*</>
        <StatusHintIcon />
      </Box>
    </>
  );
};
